<template>
  <section class="gallery-block grid-gallery">
    <div class="container">
      <div class="heading">
        <img
          src="/zic/static/images/logos/140x140.PNG"
          style="width:60px"
        />
        <h2 class="sentence my-auto">
          Your Pics are
          <div class="slidingVertical">
            <span class="vertical-center">Amazing</span>
            <span class="vertical-center">Beautiful</span>
            <span class="vertical-center">Cute</span>
            <span class="vertical-center">Delightful</span>
            <span class="vertical-center">Emotional</span>
          </div>
        </h2>
      </div>

      <div class="row">
        <div
          class="col-md-2 col-lg-3 col-sm-1 mb-4"
          v-for="image in clientImages"
          v-bind:key="image.imageName"
        >
          <b-button
            :pressed="image.selected"
            size="sm"
            pill
            variant="outline-primary"
            class="btn-pill top-left-select"
            v-on:click="choice(image.imageName,$event)"
          >
            <b-icon icon="heart"></b-icon>
          </b-button>
          <a
            class="lightbox"
            :href="image.imageName"
          >
            <img
              class="img-fluid image scale-on-hover"
              :src="image.imageName"
            />
          </a>
        </div>

        <!-- <b-pagination
                    total-rows="10"
                    per-page="1"
        ></b-pagination>-->
      </div>
    </div>
    <b-modal
      ref="progress"
      size="sm"
      hide-header="true"
      hide-footer="true"
      centered
      no-close-on-backdrop
      data-keyboard="false"
    >
      <b-spinner
        class="float-left mb-0"
        variant="info"
      ></b-spinner>
      <div class="text-center">Awesome, Processing...</div>
    </b-modal>
    <b-button
      pill
      size="sm"
      class="float-bottom"
      variant="outline-primary"
      @click="showPrintConfirm"
    >
      <b-icon
        icon="images"
        font-scale="3"
      ></b-icon>
      <b-badge
        variant="warning"
        pill
        class="keep-corner"
      >{{selections.photos.length}}</b-badge>
    </b-button>
    <b-modal
      size="sm"
      ref="print-confirm"
      centered
      title="Thats All?"
    >
      <div class="d-block text-center">
        <h6>
          You have marked only
          <span class="font-weight-bold text-success">{{selections.photos.length}}</span> as favourites
        </h6>
      </div>
      <template v-slot:modal-footer>
        <b-button-group
          class="float-right"
          size="sm"
        >
          <b-button
            variant="info"
            class="mr-3"
            @click="handlePrint('save')"
          >Save</b-button>
          <b-button
            variant="primary"
            class="mr-3"
            @click="handlePrint('print')"
          >Print</b-button>
          <b-button
            variant="danger"
            @click="handleCancel"
          >Cancel</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </section>
</template>

<script>
import baguetteBox from 'baguettebox.js'
import axios from 'axios'
import '../../static/css/rollingwords.css'
export default {
  name: 'clientgallery',
  components: {},
  data () {
    return {
      togleState: true,
      clientImages: [],
      madeChoice: false,
      selections: {
        email: this.$route.params.email,
        photos: []
      }
    }
  },
  methods: {
    loadbaguettBoxForGal: function () { },
    handleCancel () {
      this.$refs['print-confirm'].hide()
    },
    showPrintConfirm () {
      this.$refs['print-confirm'].show()
    },
    handlePrint (operation) {
      this.$refs['print-confirm'].hide()
      if (!this.madeChoice && operation === 'save') {
        this.$bvToast.toast('Thank You', {
          title: 'No Changes to the Selections ',
          variant: 'info',
          toaster: 'b-toaster-top-center',
          solid: true
        })
        return
      }
      this.$refs['progress'].show()
      axios({
        method: 'post',
        url: 'gallery/selections?operation=' + operation,
        data: this.selections,
        config: { headers: { 'Content-Type': 'application/json' } }
      }).then(response => {
        this.$refs['progress'].hide()
        this.madeChoice = false
        this.$bvToast.toast('Thank You', {
          title: 'We Have Recorded Your Decision',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          solid: true
        })
      })
    },
    choice: function (image, evnt) {
      this.madeChoice = true
      var btnElm = evnt.currentTarget

      if (btnElm.classList) {
        if (btnElm.classList.contains('selected')) {
          this.selections.photos.splice(
            this.selections.photos.indexOf(image),
            1
          )
        } else {
          this.selections.photos.push(image)
        }
        btnElm.classList.toggle('selected')
      } else {
        // For IE9
        var classes = btnElm.className.split(' ')
        var i = classes.indexOf('selected')
        if (i >= 0) {
          classes.splice(i, 1)
          this.selections.photos.splice(
            this.selections.photos.indexOf(image),
            1
          )
        } else {
          classes.push('selected')
          this.selections.photos.push(image)
        }
        btnElm.className = classes.join(' ')
      }
      btnElm.blur()
    }
  },
  beforeMount () { },
  mounted () {
    var self = this
    this.$refs['progress'].show()
    axios
      .get('gallery/selections/' + this.$route.params.email)
      .then(function (res) {
        self.selections.photos = res.data
      })
    axios
      .get('gallery/' + this.$route.params.email)
      .then(function (res) {
        self.clientImages = res.data
        self.$refs['progress'].hide()
      })
      .then(function () {
        baguetteBox.run('.grid-gallery', {
          animation: 'slideIn',
          fullScreen: true
        })
      })
  },
  created () {
    window.addEventListener('beforeunload', evnt => {
      if (this.madeChoice) {
        evnt.returnValue = 'You have unfinished selections!'
      }
    })
  }
}
</script>

<style scoped>
.gallery-block.grid-gallery {
  padding-bottom: 10px;
  padding-top: 10px;
}

.gallery-block.grid-gallery .heading {
  height: 90%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.gallery-block.grid-gallery .heading h2 {
  font-weight: bold;
  /*font-size: 1.4rem;
    text-transform: uppercase;*/
}

.gallery-block.grid-gallery a:hover {
  opacity: 0.8;
}

.gallery-block.grid-gallery .item img {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  transition: 0.4s;
}

.gallery-block.grid-gallery .item {
  margin-bottom: 20px;
}

@media (min-width: 576px) {
  .gallery-block.grid-gallery .scale-on-hover:hover {
    transform: scale(1.05);
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.15) !important;
  }
}
.top-left-select {
  position: absolute;
  margin-left: 5px;
  margin-top: 5px;
  z-index: 1;
}

.float-bottom {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.btn:hover,
.btn:focus,
.btn:active {
  background-color: #ffa600 !important; /*#007bff*/
}
.btn-outline-primary.selected {
  background-color: #ff0000 !important;
}
.keep-corner {
  top: -50px !important;
  right: -30px;
}
h2 {
  color: #fff;
  text-align: center;
}
/*Sentence*/
.sentence {
  color: #222;
  font-size: 18px;
}
.vertical-center {
  font-weight: bold;
}
.modal-content {
  background-color: #ffffffa8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ClientGallery.vue